<template>
  <div>
    <div class="modal fade show" tabindex="-1" role="dialog" aria-hidden="true" style="display:block">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
        <form class="modal-content">
          <div class="modal-header">
            <slot name="header"></slot>
          </div>
          <div class="modal-body">
            <slot name="body"></slot>
          </div>
          <div class="modal-footer">
            <slot name="footer"></slot>
          </div>
        </form>
      </div>
    </div>
    <div class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
  export default {
    name: 'Modal',
  }
</script>

<style scoped>

</style>
